import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "invoice-cost-tr" }, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Cost per unit"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Quantity"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-right",
      scope: "col"
    }, "Total cost"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-right",
      scope: "col",
      width: "2%"
    })
  ])
], -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "align-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrTooltip = _resolveComponent("NrTooltip")!
  const _component_InvoiceItemMenu = _resolveComponent("InvoiceItemMenu")!
  const _component_NrModal = _resolveComponent("NrModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", null, [
      _hoisted_1,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalSelectedLineItems, (lineItem, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: `staff-hour-${lineItem.id}-${index}`
          }, [
            (lineItem.label?.length > 15)
              ? (_openBlock(), _createElementBlock("td", _hoisted_2, [
                  _createVNode(_component_NrTooltip, {
                    label: lineItem.label
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($options.truncate(lineItem.label, { length: 15 })), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"])
                ]))
              : (_openBlock(), _createElementBlock("td", _hoisted_3, _toDisplayString(lineItem.label), 1)),
            _createElementVNode("td", null, _toDisplayString($options.formatCost(lineItem.cost, 3) || '$0.00'), 1),
            _createElementVNode("td", null, _toDisplayString(lineItem.total_count), 1),
            _createElementVNode("td", _hoisted_4, _toDisplayString($options.formatCost(lineItem.total_cost)), 1),
            _createElementVNode("td", null, [
              _createVNode(_component_InvoiceItemMenu, {
                onOnEdit: ($event: any) => ($options.onEdit(lineItem, index)),
                onOnDelete: ($event: any) => ($options.onDelete(lineItem))
              }, null, 8, ["onOnEdit", "onOnDelete"])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_NrModal, {
      show: $options.activeItemDeleteModal,
      primaryButtonText: "Delete item",
      secondaryButtonText: "Cancel",
      title: "Delete line item",
      hasSecondaryButton: "",
      onOnPrimaryClick: $options.deleteInvoiceLineItem,
      onOnSecondaryClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setActiveModal(''))),
      onOnCloseClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActiveModal('')))
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, " Are you sure you want to remove " + _toDisplayString(this.invoiceItemToEdit?.label) + " from the list? ", 1)
      ]),
      _: 1
    }, 8, ["show", "onOnPrimaryClick"])
  ], 64))
}